import router from "../router";
import Vue from "vue";
import model from "@/api/index";
import $config from "@/config/baseConfig";

/**
 * @description: 缓存
 * @param {String} name key
 * @param {String, Object} value value
 * @return: cache value
 * @use 存： this.common.cache.set("name", value);
 *      取： const value = this.common.cache.get("name");
 */
const cacheObj = {
  set(name, value, expire) {
    if (expire) {
      return Vue.ls.set(name, value, expire);
    } else {
      return Vue.ls.set(name, value);
    }
  },
  get(name) {
    return Vue.ls.get(name);
  },
  remove(name) {
    return Vue.ls.remove(name);
  },
};
export const cache = cacheObj;

/**
 * @description: sessionStorage缓存
 * @param {type}
 * @return:
 * @use:
 */
export const cacheSession = {
  set(name, value) {
    sessionStorage.setItem(name, JSON.stringify(value));
  },
  get(name) {
    const str = sessionStorage.getItem(name);
    return JSON.parse(str);
  },
  remove(name) {
    sessionStorage.removeItem(name);
  },
};

/**
 * @description: 路由跳转
 */
export const jump = (name, query = {}, params = {}) => {
  router.push({
    name: name,
    query: query,
    params: params,
  });
};

/**
 * @description: 格式化日期时间
 * @param {type}
 * @return:
 * @use:
 */
export const formatDate = (d, f) => {
  let date = new Date();
  if (d && typeof d === "string") {
    date = new Date(d);
  } else if (d) {
    date = d;
  }
  var fmt = f ? f : "yyyy-MM-dd";
  // if (arguments[0] instanceof Date) date = arguments[0];
  // if (arguments[0] instanceof String) fmt = arguments[0];
  // if (arguments[1] instanceof String) fmt = arguments[1];

  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length),
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length),
      );
  return fmt;
};

/**
 * @description: 获取日期的星期
 * @param {type}
 * @return:
 * @use:
 */
export const getWeek = date => {
  if (!date) {
    date = formatDate();
  }
  const week = new Date(date).getDay();
  return week;
};

/**
 * @description: 日期计算
 * @param {type}
 * @return:
 * @use:
 */
export const countDate = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  let month = d.getMonth() + 1;
  let day = d.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  const val = d.getFullYear() + "-" + month + "-" + day;
  return val;
};

export const getTimestamp = date => {
  return Number(new Date(date));
};

/**
 * @description: tree转数组
 * @param {type}
 * @return:
 * @use:
 */
export const treeTransArray = (tree, key) => {
  return [].concat(
    ...tree.map(item => {
      if (item[key] && item[key].length) {
        return [].concat(item, ...treeTransArray(item[key]));
      } else {
        return item;
      }
    }),
  );
};

/**
 * @description: 获取头像
 * @param {type}
 * @return:
 * @use:
 */
export const getAvatarUrl = url => {
  if (url && url != "string") {
    if (url.indexOf($config.fileUrl) > -1) {
      return url;
    }
    return $config.fileUrl + "/" + url;
  } else {
    return "/images/avatar.jpg";
  }
};
/**
 * @description: 统一请求下拉数据
 * @param {type}
 * @return:
 * @use:
 */
export const getSelectData = codes => {
  codes = codes.join(",");
  return new Promise((resolve, reject) => {
    model
      .$post("Common_SelectData", { Code: codes })
      .then(res => {
        resolve(res.data);
      })
      .catch(() => {
        reject();
      });
  });
};

export const IdentityCodeValid = code => {
  let home = "",
    birthday = "",
    sex = "";
  code = code.replace(/^\s*|\s*$/g, "");
  const returnObj = { state: "error", msg: "" };
  const city = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
  };
  if (
    !code ||
    !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
      code,
    )
  ) {
    returnObj.msg = "身份证号格式错误";
    return returnObj;
  }
  if (!city[code.substring(0, 2)]) {
    returnObj.msg = "地址编码错误";
    return returnObj;
  }
  if (code.length == 18) {
    //18位身份证需要验证最后一位校验位
    var codeArr = code.split("");
    var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //加权因子
    var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2]; //校验位
    var sum = 0;
    for (var i = 0; i < 17; i++) {
      sum += codeArr[i] * factor[i];
    }
    if (parity[sum % 11] != codeArr[17]) {
      returnObj.msg = "校验位错误";
      (home = ""), (birthday = ""), (sex = "");
      return returnObj;
    }
  }
  //省份
  home = city[code.substring(0, 2)];
  //生日
  birthday =
    code.substring(6, 10) +
    "-" +
    code.substring(10, 12) +
    "-" +
    code.substring(12, 14);
  //性别
  if (code.length == 15) {
    sex = code.substring(14, 15) % 2 == 0 ? 2 : 1;
  } else if (code.length == 18) {
    sex = code.substring(14, 17) % 2 == 0 ? 2 : 1;
  }
  returnObj.state = "success";
  returnObj.nativePlace = home;
  returnObj.sex = sex;
  returnObj.birthday = birthday;
  return returnObj;
};
export const getAges = str => {
  var r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
  if (r == null) return false;
  var d = new Date(r[1], r[3] - 1, r[4]);
  if (
    d.getFullYear() == r[1] &&
    d.getMonth() + 1 == r[3] &&
    d.getDate() == r[4]
  ) {
    var Y = new Date().getFullYear();
    return Y - r[1];
  }
  return "输入的日期格式错误！";
};
export const postConfirm = (
  _this,
  api,
  json,
  userData,
  user,
  callback = "",
) => {
  _this
    .$post(api, json)
    .then(res => {
      if (callback) {
        callback(res);
      }
      if (
        (user.bookingPaymentMode == "1" &&
          formatDate() !== _this.info.treatmentDate) ||
        user.bookingPaymentMode == "3"
      ) {
        // 不支付模式并且预约挂号，免支付模式，直接跳转结果页
        const id =
          res.data && res.data.id ? res.data.id : res.data.cardBookingId;
        _this.$router.push({
          name: "servePreOrderResult",
          query: { Id: id },
        });
      } else {
        _this.$router.push({
          name: "servePreOrderPay",
          query: { Id: res.data.id },
        });
      }

      if (userData.diagnosisCardNo) {
        const id =
          res.data && res.data.id ? res.data.id : res.data.cardBookingId;
        userData.cardBookingId = id;

        userData.details.map(p => {
          p.cardBookingId = id;
        });
        _this.$post("AddScreeningForm_RecordAsync", userData).then(() => {});
      }
    })
    .catch(() => {
      if (userData.diagnosisCardNo) {
        userData.cardBookingId = 0;
        userData.details.map(p => {
          p.cardBookingId = 0;
        });
        _this.$post("AddScreeningForm_RecordAsync", userData).then(() => {});
      }
    });
};

export const checkPhone = phone => {
  const r = /^\+?[1-9][0-9]*$/;
  if (r.test(phone) && phone && (phone.length == 7 || phone.length == 11)) {
    return true;
  }
  return false;
};
